import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../hooks/ThemeContext";
import { Home, ArrowLeft } from "lucide-react";

const g = "linear-gradient(135deg, #f43f5e 0%, #a855f7 50%, #6366f1 100%)";

function NotFound() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <div
      className="relative flex-1 flex flex-col items-center justify-center px-4 py-20 overflow-hidden"
      style={{
        backgroundColor: isDark ? "#07070a" : "#f9fafb",
        color: isDark ? "#fff" : "#111",
      }}
    >
      {/* Orbs dark */}
      {isDark && (
        <>
          <div
            className="absolute top-[-8%] right-[-4%] w-[420px] h-[420px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #a855f730 0%, transparent 70%)",
              filter: "blur(90px)",
            }}
          />
          <div
            className="absolute bottom-[-8%] left-[-4%] w-[380px] h-[380px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #f43f5e28 0%, transparent 70%)",
              filter: "blur(80px)",
            }}
          />
        </>
      )}

      <div className="relative z-10 text-center max-w-lg w-full">
        {/* Badge */}
        <div className="flex justify-center mb-6">
          <span
            className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold border ${
              isDark
                ? "bg-white/[0.06] border-white/[0.10] text-gray-300"
                : "bg-rose-50 border-rose-200 text-rose-600"
            }`}
          >
            Erreur 404
          </span>
        </div>

        {/* Numéro 404 gradient */}
        <div
          className="text-[8rem] sm:text-[10rem] font-black leading-none mb-2 select-none"
          style={{
            backgroundImage: g,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          404
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold mb-3">
          Page introuvable
        </h1>
        <p
          className={`text-base mb-10 ${isDark ? "text-gray-400" : "text-gray-500"}`}
        >
          Cette page n'existe pas ou vous n'y avez pas accès.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 px-6 py-3 rounded-xl text-white font-semibold shadow-lg transition-opacity hover:opacity-90"
            style={{ background: g }}
          >
            <Home className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <button
            onClick={() => window.history.back()}
            className={`flex items-center gap-2 px-6 py-3 rounded-xl border font-medium transition-colors ${
              isDark
                ? "border-white/[0.10] text-gray-300 hover:bg-white/[0.05]"
                : "border-gray-200 text-gray-600 hover:bg-gray-100"
            }`}
          >
            <ArrowLeft className="w-4 h-4" />
            Page précédente
          </button>
        </div>

        <p
          className={`mt-8 text-sm ${isDark ? "text-gray-600" : "text-gray-400"}`}
        >
          Besoin d'aide ?{" "}
          <Link
            to="/contact"
            className="underline"
            style={{
              backgroundImage: g,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Contactez-nous
          </Link>
        </p>
      </div>
    </div>
  );
}

export default NotFound;
